// interface data {
//     id: string;
//     auditFocus: string;
//     areas: [];
//     organizationId: string;
//   }

export const auditFocusArea: any = {
  id: "",
  auditFocus: "",
  areas: [{ name: "" }],
  organizationId: "",
};
